<template>
  <footer class="footer">
	<div class="container">
    <h5 v-html="$t('footerTxt2')"/>
		<h6 v-html="$t('footer_txt')"/>
	</div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
</style>
